<template>
    <div>
        <CustomTable
            :items.sync="tables.fieldMapping.items"
            :fields="traslateLabels(tables.fieldMapping.fields)"
            v-bind="tables.fieldMapping"
        >
            <template #name="{ index }">
                <CInput
                    :value.sync="tables.fieldMapping.items[index].name"
                    :placeholder="$t('enter_the_name')"
                    :invalidFeedback="$t('name_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #value="{ index }">
                <CInput
                    :value.sync="tables.fieldMapping.items[index].value"
                    :placeholder="$t('enter_the_value')"
                    :invalidFeedback="$t('value_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #options="{ index }">
                <div class="table-options">
                    <CButton
                        color="danger"
                        variant="outline"
                        square
                        size="sm"
                        @click="deleteItemToTable('fieldMapping', index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilTrash"
                        />
                    </CButton>
                </div>
            </template>
            <template #no-items-view>
                <div class="block-no-items section">
                    <h2 class="section__title text-no-items">
                        {{ $t("add_field_mapping") }}
                    </h2>
                    <CButton
                        color="success"
                        class="button m-2 shadow"
                        @click="addItemToTable('fieldMapping')"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.cilPlus" />
                        </span>
                        <span class="button__text">
                            {{ $t("add") }}
                        </span>
                    </CButton>
                </div>
            </template>
            <template #under-table>
                <CButton
                    color="success"
                    class="button m-2 shadow"
                    @click="addItemToTable('fieldMapping')"
                    v-if="tables.fieldMapping.items.length > 0"
                >
                    <span class="button__icon">
                        <CIcon :content="$options.icons.cilPlus" />
                    </span>
                    <span class="button__text">
                        {{ $t("add") }}
                    </span>
                </CButton>
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import CustomTable from "~/components/CustomTable";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";

export default {
    name: "TableFieldMapping",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
    },
    components: {
        CustomTable,
    },
    data() {
        return {
            tables: {
                fieldMapping: {
                    items: [],
                    fields: [
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "value",
                            label: "value",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "options",
                            label: "options",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                    ],
                    loading: false,
                },
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        value: {
            type: Array | Object,
            default: () => {
                return [];
            },
        },
    },
    watch: {
        "tables.fieldMapping.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.tables.fieldMapping.items = newValue;
            }
        },
    },
    methods: {},
    mounted() {
        if (Array.isArray(this.value)) {
            this.tables.fieldMapping.items = this.value;
        }
    },
};
</script>

<style>
</style>